(() => {
  const theme = window.frontlineTheme || { root: '/', cartUrl: '/cart', currency: 'USD' };
  const root = theme.root || '/';
  const drawer = document.querySelector('[data-cart-drawer]');
  const drawerBody = document.querySelector('[data-cart-drawer-body]');
  const drawerFooter = document.querySelector('[data-cart-drawer-footer]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const mobileMenuToggle = document.querySelector('[data-mobile-menu-toggle]');
  const money = (cents) => new Intl.NumberFormat(undefined, { style: 'currency', currency: theme.currency || 'USD' }).format((Number(cents) || 0) / 100);

  const setDrawer = (open) => {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', String(!open));
    document.body.style.overflow = open ? 'hidden' : '';
  };

  /*
   * CornerCart owns the active customer-facing cart when its app embed is enabled.
   * Keep the native drawer as a safe fallback for preview stores or when the app
   * has been disabled, but never layer it underneath CornerCart in production.
   */
  const openCornerCart = () => {
    const corner = window.corner;
    if (!corner || typeof corner.do !== 'function') return false;
    try {
      setDrawer(false);
      corner.do('refreshCart');
      corner.do('openCart');
      return true;
    } catch (_) {
      return false;
    }
  };

  const setMobileMenu = (open) => {
    if (!mobileMenu) return;
    mobileMenu.classList.toggle('is-open', open);
    mobileMenu.setAttribute('aria-hidden', String(!open));
    mobileMenuToggle?.setAttribute('aria-expanded', String(open));
    document.body.classList.toggle('ff-mobile-menu-open', open);
    if (open) mobileMenu.querySelector('[data-mobile-menu-close]')?.focus();
    if (!open) mobileMenuToggle?.focus();
  };
  const updateCounts = (count) => document.querySelectorAll('.js-cart-count').forEach((node) => { node.textContent = count; });
  const cartUrl = (endpoint) => `${root}${endpoint}`.replace(/([^:]\/)\/+/, '$1');

  const cartLine = (item) => `
    <article class="ff-cart-line">
      <a class="ff-cart-line__image" href="${item.url}"><img src="${item.image}" alt="${item.product_title}"></a>
      <div>
        <p class="ff-label" style="color:var(--ff-red);margin:0 0 .3rem">${item.product_title}</p>
        <a class="ff-card__title" style="color:#fff" href="${item.url}">${item.title}</a>
        <div class="ff-price" style="font-size:1.45rem;margin-top:.25rem">${money(item.final_line_price)}</div>
        <div class="ff-cart-line__controls">
          <div class="ff-cart-line__quantity" aria-label="Quantity controls for ${item.title}">
            <button type="button" data-cart-change data-cart-key="${item.key}" data-cart-quantity="${Math.max(item.quantity - 1, 0)}" aria-label="Decrease quantity">−</button>
            <span class="ff-label" style="font-size:.65rem">${item.quantity}</span>
            <button type="button" data-cart-change data-cart-key="${item.key}" data-cart-quantity="${item.quantity + 1}" aria-label="Increase quantity">+</button>
          </div>
          <button type="button" data-cart-change data-cart-key="${item.key}" data-cart-quantity="0" class="ff-label" style="border:0;background:transparent;color:rgba(255,255,255,.6);cursor:pointer">REMOVE</button>
        </div>
      </div>
    </article>`;
  const renderCart = (cart) => {
    if (!drawerBody || !drawerFooter) return;
    updateCounts(cart.item_count);
    if (!cart.items.length) {
      drawerBody.innerHTML = '<div style="padding:4rem 1rem;text-align:center"><p class="ff-display" style="font-size:2.4rem">THE CART IS CLEAR</p><p class="ff-body" style="color:rgba(255,255,255,.64)">Select a formula or stack to build your next deployment.</p></div>';
      drawerFooter.innerHTML = '';
      return;
    }
    drawerBody.innerHTML = cart.items.map(cartLine).join('');
    drawerFooter.innerHTML = `<div style="display:flex;justify-content:space-between;align-items:end;margin-bottom:1rem"><span class="ff-label" style="color:rgba(255,255,255,.64)">SUBTOTAL</span><span class="ff-display" style="font-size:2rem">${money(cart.total_price)}</span></div><p class="ff-body" style="font-size:.76rem;color:rgba(255,255,255,.62);margin:.2rem 0 1rem">Secure checkout is completed through Shopify.</p><a class="ff-button" style="width:100%" href="${theme.cartUrl}">${theme.strings.cartReady || 'AUTHORIZE CHECKOUT'}</a>`;
  };
  const getCart = async () => {
    const response = await fetch(cartUrl('cart.js'), { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Cart request failed');
    const cart = await response.json();
    renderCart(cart);
    return cart;
  };
  const updateCart = async (key, quantity) => {
    const response = await fetch(cartUrl('cart/change.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
    if (!response.ok) throw new Error('Cart update failed');
    renderCart(await response.json());
  };
  const addToCart = async (form) => {
    const response = await fetch(cartUrl('cart/add.js'), { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
    if (!response.ok) throw new Error('Cart add failed');
    await getCart();
    if (!openCornerCart()) setDrawer(true);
  };

  document.addEventListener('click', async (event) => {
    const mobileToggle = event.target.closest('[data-mobile-menu-toggle]');
    if (mobileToggle) { event.preventDefault(); setMobileMenu(!mobileMenu?.classList.contains('is-open')); return; }
    if (event.target.closest('[data-mobile-menu-close]')) { event.preventDefault(); setMobileMenu(false); return; }
    const mobileLink = event.target.closest('[data-mobile-menu] a');
    if (mobileLink) setMobileMenu(false);
    const toggle = event.target.closest('[data-cart-drawer-toggle]');
    if (toggle) {
      event.preventDefault();
      if (openCornerCart()) return;
      setDrawer(!drawer?.classList.contains('is-open'));
      return;
    }
    if (event.target.closest('[data-cart-drawer-close]')) { event.preventDefault(); setDrawer(false); }
    const change = event.target.closest('[data-cart-change]');
    if (change) { event.preventDefault(); try { await updateCart(change.dataset.cartKey, Number(change.dataset.cartQuantity)); } catch (_) { window.alert(theme.strings.cartError); } }
    const quantity = event.target.closest('[data-quantity-change]');
    if (quantity) { const input = document.querySelector(quantity.dataset.quantityChange); if (input) input.value = Math.max(1, Number(input.value || 1) + Number(quantity.dataset.quantityDelta)); }
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && mobileMenu?.classList.contains('is-open')) setMobileMenu(false);
  });
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form.js-product-form');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    if (button) button.disabled = true;
    try { await addToCart(form); } catch (_) { window.alert(theme.strings.cartError); } finally { if (button) button.disabled = false; }
  });
  const initHero = () => {
    const hero = document.querySelector('[data-hero]');
    if (!hero) return;
    const content = hero.querySelector('[data-hero-content]');
    const slides = [...hero.querySelectorAll('[data-hero-slide]')];
    const copies = [...hero.querySelectorAll('[data-hero-copy]')];
    const dots = [...hero.querySelectorAll('[data-hero-dot]')];
    if (!slides.length || !copies.length) return;
    let current = 0;
    const show = (index) => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, itemIndex) => slide.classList.toggle('is-active', itemIndex === current));
      copies.forEach((copy, itemIndex) => copy.classList.toggle('is-active', itemIndex === current));
      dots.forEach((dot, itemIndex) => dot.classList.toggle('is-active', itemIndex === current));
      content?.classList.toggle('ff-hero__content--right', copies[current]?.classList.contains('ff-hero__copy--right'));
    };
    show(0);
    if (slides.length < 2) return;
    dots.forEach((dot) => dot.addEventListener('click', () => show(Number(dot.dataset.heroDot))));
    window.setInterval(() => show(current + 1), 7000);
  };
  const initProductGalleries = () => {
    document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
      if (gallery.dataset.galleryReady === 'true') return;
      gallery.dataset.galleryReady = 'true';
      const slides = [...gallery.querySelectorAll('[data-product-gallery-slide]')];
      const thumbs = [...gallery.querySelectorAll('[data-product-gallery-thumb]')];
      const previous = gallery.querySelector('[data-product-gallery-previous]');
      const next = gallery.querySelector('[data-product-gallery-next]');
      if (slides.length < 2) return;
      let current = 0;
      let touchStartX = null;
      const show = (index, focusThumb = false) => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => {
          const active = slideIndex === current;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
        });
        thumbs.forEach((thumb, thumbIndex) => {
          const active = thumbIndex === current;
          thumb.classList.toggle('is-active', active);
          thumb.setAttribute('aria-selected', String(active));
          if (active) thumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
        });
        if (focusThumb && thumbs[current]) thumbs[current].focus();
      };
      thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => show(index)));
      previous?.addEventListener('click', () => show(current - 1));
      next?.addEventListener('click', () => show(current + 1));
      gallery.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') { event.preventDefault(); show(current - 1, true); }
        if (event.key === 'ArrowRight') { event.preventDefault(); show(current + 1, true); }
      });
      gallery.addEventListener('touchstart', (event) => { touchStartX = event.changedTouches[0]?.screenX ?? null; }, { passive: true });
      gallery.addEventListener('touchend', (event) => {
        const touchEndX = event.changedTouches[0]?.screenX ?? null;
        if (touchStartX === null || touchEndX === null) return;
        const movement = touchEndX - touchStartX;
        if (Math.abs(movement) > 42) show(current + (movement < 0 ? 1 : -1));
        touchStartX = null;
      }, { passive: true });
    });
  };
  const initProductVariants = () => {
    document.querySelectorAll('[data-product-section]').forEach((section) => {
      if (section.dataset.variantReady === 'true') return;
      const form = section.querySelector('form.js-product-form');
      const options = [...section.querySelectorAll('[data-product-option]')];
      const variantData = section.querySelector('[data-product-variants]');
      const variantMediaData = section.querySelector('[data-product-variant-media]');
      const variantId = section.querySelector('[data-product-variant-id]');
      if (!form || !variantData || !variantId || !options.length) return;
      let variants;
      let variantMediaMap = {};
      try {
        variants = JSON.parse(variantData.textContent);
        if (variantMediaData) variantMediaMap = JSON.parse(variantMediaData.textContent);
      } catch (_) { return; }
      section.dataset.variantReady = 'true';

      const getSelected = () => options.map((select) => select.value);
      const findVariant = (selected) => variants.find((variant) => variant.options.every((value, index) => value === selected[index]));
      const updateDisabledValues = (selected) => options.forEach((select, optionIndex) => {
        [...select.options].forEach((option) => {
          const possible = variants.some((variant) => variant.available && variant.options[optionIndex] === option.value && variant.options.every((value, index) => index === optionIndex || value === selected[index]));
          option.disabled = !possible;
        });
      });
      const updateVariant = () => {
        const selected = getSelected();
        updateDisabledValues(selected);
        const variant = findVariant(selected);
        const submit = form.querySelector('[data-variant-submit]');
        if (!variant) {
          if (submit) submit.disabled = true;
          return;
        }
        variantId.value = variant.id;
        variantId.dispatchEvent(new Event('change', { bubbles: true }));
        form.dataset.variantId = variant.id;
        if (submit) {
          submit.disabled = !variant.available;
          submit.textContent = variant.available ? (submit.dataset.addToCartLabel || 'Add to Cart') : (submit.dataset.soldOutLabel || 'SOLD OUT');
          submit.setAttribute('aria-disabled', String(!variant.available));
        }
        const price = Number(variant.price || 0);
        const compareAtPrice = Number(variant.compare_at_price || 0);
        const discountPercent = Number.isFinite(price) && Number.isFinite(compareAtPrice) && price > 0 && compareAtPrice > price
          ? Math.round(((compareAtPrice - price) * 100) / compareAtPrice)
          : null;
        const isSale = discountPercent !== null;
        section.querySelectorAll('[data-product-price]').forEach((node) => { node.textContent = money(price); });
        section.querySelectorAll('[data-product-compare-wrap]').forEach((node) => { node.hidden = !isSale; });
        section.querySelectorAll('[data-product-compare]').forEach((node) => { node.textContent = money(compareAtPrice); });
        const savingsLabel = isSale ? `SAVE ${discountPercent}%` : '';
        section.querySelectorAll('[data-product-sale]').forEach((node) => { node.textContent = savingsLabel; });
        section.querySelectorAll('[data-product-sale-badge]').forEach((node) => { node.hidden = !isSale; node.style.display = isSale ? '' : 'none'; node.textContent = savingsLabel; });
        section.querySelectorAll('[data-product-inventory]').forEach((node) => {
          const tracked = variant.inventory_management !== null && variant.inventory_management !== undefined;
          node.hidden = !tracked;
          node.style.color = variant.available ? 'var(--ff-olive)' : 'var(--ff-rust)';
          const text = node.querySelector('[data-product-inventory-text]');
          if (text) text.textContent = variant.available ? (node.dataset.inStockLabel || 'IN STOCK') : (node.dataset.outOfStockLabel || 'OUT OF STOCK');
        });
        const mediaId = variantMediaMap[String(variant.id)] || variant.featured_media?.id || variant.featured_image?.id || variant.featured_image?.media_id;
        if (mediaId) {
          const thumb = section.querySelector(`[data-product-gallery-thumb="${mediaId}"]`);
          const slide = section.querySelector(`[data-media-id="${mediaId}"]`);
          if (thumb) thumb.click();
          else if (slide) {
            section.querySelectorAll('[data-product-gallery-slide]').forEach((item) => {
              const active = item === slide;
              item.classList.toggle('is-active', active);
              item.setAttribute('aria-hidden', String(!active));
            });
          }
        }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      };
      options.forEach((select) => select.addEventListener('change', updateVariant));
      updateVariant();
    });
  };
  const initCardVariants = () => {
    document.querySelectorAll('[data-card-variant-card]').forEach((card) => {
      if (card.dataset.cardVariantReady === 'true') return;
      const panel = card.querySelector('[data-card-options-panel]');
      const toggle = card.querySelector('[data-card-options-toggle]');
      const close = card.querySelector('[data-card-options-close]');
      const form = card.querySelector('[data-card-variant-form]');
      const options = [...card.querySelectorAll('[data-card-product-option]')];
      const variantData = card.querySelector('[data-card-product-variants]');
      const variantId = card.querySelector('[data-card-variant-id]');
      if (!panel || !toggle || !form || !variantData || !variantId || !options.length) return;
      let variants;
      try { variants = JSON.parse(variantData.textContent); } catch (_) { return; }
      card.dataset.cardVariantReady = 'true';
      const setOpen = (open) => {
        panel.hidden = !open;
        toggle.setAttribute('aria-expanded', String(open));
        if (open) panel.querySelector('select')?.focus();
      };
      const selectedValues = () => options.map((select) => select.value);
      const matchVariant = (values) => variants.find((variant) => variant.options.every((value, index) => value === values[index]));
      const updateOptionAvailability = (values) => options.forEach((select, optionIndex) => {
        [...select.options].forEach((option) => {
          option.disabled = !variants.some((variant) => variant.available && variant.options[optionIndex] === option.value && variant.options.every((value, index) => index === optionIndex || value === values[index]));
        });
      });
      const updateCard = () => {
        const values = selectedValues();
        updateOptionAvailability(values);
        const variant = matchVariant(values);
        const submit = form.querySelector('[data-card-variant-submit]');
        if (!variant) { if (submit) submit.disabled = true; return; }
        variantId.value = variant.id;
        variantId.dispatchEvent(new Event('change', { bubbles: true }));
        if (submit) {
          submit.disabled = !variant.available;
          submit.textContent = variant.available ? (submit.dataset.addToCartLabel || 'Add to Cart') : (submit.dataset.soldOutLabel || 'SOLD OUT');
        }
        const price = Number(variant.price || 0);
        const compare = Number(variant.compare_at_price || 0);
        const percent = Number.isFinite(price) && Number.isFinite(compare) && price > 0 && compare > price ? Math.round(((compare - price) * 100) / compare) : null;
        card.querySelectorAll('[data-card-price] [data-product-price]').forEach((node) => { node.textContent = money(price); });
        card.querySelectorAll('[data-card-price] [data-product-compare-wrap]').forEach((node) => { node.hidden = percent === null; });
        card.querySelectorAll('[data-card-price] [data-product-compare]').forEach((node) => { node.textContent = money(compare); });
        card.querySelectorAll('[data-card-price] [data-product-sale]').forEach((node) => { node.textContent = percent === null ? '' : `SAVE ${percent}%`; });
        card.querySelectorAll('[data-card-sale-badge]').forEach((node) => { node.hidden = percent === null; node.style.display = percent === null ? 'none' : ''; node.textContent = percent === null ? '' : `SAVE ${percent}%`; });
      };
      toggle.addEventListener('click', () => setOpen(panel.hidden));
      close?.addEventListener('click', () => setOpen(false));
      options.forEach((select) => select.addEventListener('change', updateCard));
      updateCard();
    });
  };
  const initCatalogTabs = () => {
    document.querySelectorAll('[data-catalog]').forEach((catalog) => {
      if (catalog.dataset.catalogReady === 'true') return;
      const tabs = [...catalog.querySelectorAll('[data-catalog-tab]')];
      const panels = [...catalog.querySelectorAll('[data-catalog-panel]')];
      if (!tabs.length || !panels.length) return;
      catalog.dataset.catalogReady = 'true';
      const activate = (tab, focus = false) => {
        const panelId = tab.dataset.catalogTab;
        tabs.forEach((item) => {
          const selected = item === tab;
          item.classList.toggle('is-active', selected);
          item.setAttribute('aria-selected', String(selected));
          item.tabIndex = selected ? 0 : -1;
        });
        panels.forEach((panel) => {
          const selected = panel.id === panelId;
          panel.hidden = !selected;
          panel.classList.toggle('is-active', selected);
        });
        if (focus) tab.focus();
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', (event) => {
          let nextIndex = null;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;
          if (nextIndex === null) return;
          event.preventDefault();
          activate(tabs[nextIndex], true);
        });
      });
    });
  };
  document.addEventListener('DOMContentLoaded', () => { getCart().catch(() => {}); initHero(); initProductGalleries(); initProductVariants(); initCardVariants(); initCatalogTabs(); });
  document.addEventListener('shopify:section:load', () => { initProductGalleries(); initProductVariants(); initCardVariants(); initCatalogTabs(); });
})();
